<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <!-- <el-button-group class="mb-3">
      <search-form :fields="search" />
    </el-button-group> -->

    <el-row type="flex" justify="left">
      <el-col :span="20">
        <search-form :fields="search" />
        <el-button v-if="hasPermsOrderImportsImport" @click="jumpImportOrder"><i class="el-icon-upload2" />导入订单
        </el-button>

        <!-- <el-popconfirm
          confirm-button-text="确定"
          cancel-button-text="取消"
          icon="el-icon-info"
          icon-color="red"
          title="确认离线导出么？"
          @confirm="rsyncExport()"
        >
          <el-button slot="reference"><i class="el-icon-download" />离线导出</el-button>
        </el-popconfirm>
        <button-link :to="`downloads`"><i class="el-icon-download" />下载中心</button-link> -->
      </el-col>
    </el-row>

    <el-divider content-position="left">销售单记录</el-divider>

    <el-table :data="orderImports" resource="order-imports">
      <!-- 序号 导入时间 导入仓库 创建时间 创建人 下单状态（成功10/失败10） 发货状态（待发货10/已发货10） 操作（查询订单、生成订单、导出物流信息） -->
      <el-table-column prop="id" label="序号" width="100" align="center" />
      <el-table-column prop="batch_no" label="批次号" />
      <el-table-column prop="warehouse_code" label="所属仓库">
        <template #default="{ row }">
          {{ row.warehouse.name }}
        </template>
      </el-table-column>
      <el-table-column prop="op_name" label="操作人员" />

      <el-table-column prop="status" label="下单状态">
        <template #default="{ row }"> 已下单{{ row.orders.success }}/未下单{{ row.orders.fail }}</template>
      </el-table-column>

      <el-table-column prop="status" label="发货状态">
        <template #default="{ row }"> 已发货{{ row.express.success }}/未发货{{ row.express.fail }}</template>
      </el-table-column>

      <el-table-column prop="created_at" label="导入时间" width="170" />
      <el-table-column label="操作" width="100">
        <template #default="{ row, $index }">
          <el-dropdown>
            <el-button size="small">操作</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item icon="el-icon-view" v-if="hasPermsOrderImportDetails">
                <router-link :to="'/order-import-details?batch_no=' + row.batch_no">
                  <el-button type="text" size="small">查询订单</el-button>
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-tickets" v-if="hasPermsOrderImportsOrderOffline">
                <router-link :to="'/order-import-details?batch_no=' + row.batch_no">
                  <el-button type="text" size="small">生成订单</el-button>
                </router-link>
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-download" divided v-if="hasPermsOrderImportsExport">
                <router-link :to="'/order-import-details?batch_no=' + row.batch_no">
                  <el-button type="text" size="small">导出物流信息</el-button>
                </router-link>
                <!-- <el-button type="text" size="small">导出物流信息</el-button> -->
              </el-dropdown-item>
              <el-dropdown-item icon="el-icon-delete" divided v-if="hasPermsOrderImportsDelete">
                <el-popconfirm
                  confirm-button-text="确认"
                  cancel-button-text="不用了"
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定要删除此销售单吗？删除后将不可恢复！"
                  @confirm="onDestroyConfirm(row)"
                >
                  <el-button type="text" size="small" slot="reference">删除</el-button>
                </el-popconfirm>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>

    <el-dialog title="销售单导入" :visible.sync="updateImportDialog" width="400px" append-to-body>
      <el-select v-model="warehouse_code" clearable filterable placeholder="请选择所属仓库">
        <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.code">
          <span style="float: left">{{ item.name }}<span v-if="item.is_default == 1" style="color:coral"
          >[默认]</span></span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.city + '/' + item.address }}</span>
        </el-option>
      </el-select>
      <p>
        <el-upload
          class="upload-demo"
          ref="upload"
          action=""
          :limit="1"
          accept=".xls"
          :multiple="false"
          :on-remove="handleRemove"
          :on-change="fileChange"
          :on-exceed="uploadExceed"
          :before-upload="beforeUpload"
          :before-remove="beforeRemove"
          :file-list="fileList"
          :auto-upload="false"
        >
          <!-- .xls格式：application/vnd.ms-excel .xlsx格式：application/vnd.openxmlformats-officedocument.spreadsheetml.sheet -->
          <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="onUpdateImport">上传到服务器
          </el-button>
          <el-link target="_blank" href="/assets/doc/导入模版.xls" style="margin-left: 20px;" size="small" plain>
            <i class="el-icon-download" />
            模版下载
          </el-link>
      <div slot="tip" class="el-upload__tip">
        只能上传xls文件, 文件大小不超过10M
      </div>
      </el-upload>
      </p>
    </el-dialog>
  </el-card>
</template>

<script>
import { destroyOrderImport, exportOrder, getOrderImports, importOrder, importOrderOffline } from '@/api/order-imports'
import { warehouseList } from '@/api/warehouses'
import { can, getFirstError, getMessage } from '@/libs/utils'
import ButtonLink from '@c/ButtonLink'
import RowDestroy from '@c/LzTable/RowDestroy'
// import RowToEdit from '@c/LzTable/RowToEdit'
import Pagination from '@c/Pagination'
import SearchForm from '@c/SearchForm'

export default {
  name: 'Index',
  components: {
    // RowToEdit,
    ButtonLink,
    RowDestroy,
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        {
          field: 'express',
          label: '收件信息(手机、姓名)',
        },
        {
          field: 'username',
          label: '购买账户',
        },
        {
          field: 'order_id',
          label: '线下订单号',
        },
        {
          field: 'created_at',
          label: '导入时间',
          type: 'el-date-picker',
        },
      ],
      orderImports: [],
      page: null,

      // 1 待处理,2 重复数据,3 数据不完整,4 快递公司不在范围内,5 商品解析异常,6 地址解析异常,7 上传中,8 上传成功,9 上传失败

      status: '',
      updateImportDialog: false, // 导入
      importForm: {},
      fileList: [],
      file: null,

      query: {},
      warehouse_code: '',
      warehouseList: [],
      // 权限
      // 导入销售订单
      hasPermsOrderImportsImport: false,
      // 查询订单
      hasPermsOrderImportDetails: false,
      // 生成订单
      hasPermsOrderImportsOrderOffline: false,
      // 导出物流信息
      hasPermsOrderImportsExport: false,
      // 删除销售订单
      hasPermsOrderImportsDelete: false,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query
        this.loadData()
      },
      immediate: true,
    },
  },
  created() {
    // 导入销售订单
    this.hasPermsOrderImportsImport = can('order.imports.import')
    // 查询订单
    this.hasPermsOrderImportDetails = can('order-import-details')
    // 生成订单
    this.hasPermsOrderImportsOrderOffline = can('order.imports.order.offline')
    // 导出物流信息
    this.hasPermsOrderImportsExport = can('order.imports.export')
    // 删除销售订单
    this.hasPermsOrderImportsDelete = can('order-imports.delete')

    this.loadWarehouse()
  },
  methods: {
    async loadWarehouse() {
      const { data } = await warehouseList()
      console.log(data)
      this.warehouseList = data
    },
    async loadData() {
      const {
        data: { data, meta },
      } = await getOrderImports(this.query)
      this.orderImports = data
      this.page = meta
    },
    // 1 待处理,2 重复数据,3 数据不完整,4 快递公司不在范围内,5 商品解析异常,6 地址解析异常,7 上传中,8 上传成功,9 上传失败
    getStatusTag(status) {
      let tag = {
        type: 'info',
        message: '待处理',
      }
      switch (status) {
        case 2:
          tag = {
            type: 'warning',
            message: '重复数据',
          }
          break
        case 8:
          tag = {
            type: 'warning',
            message: '数据不完整',
          }
          break
        case 9:
          tag = {
            type: 'warning',
            message: '快递公司不在范围内',
          }
          break
        case 3:
          tag = {
            type: 'warning',
            message: '商品解析异常',
          }
          break
        case 4:
          tag = {
            type: 'warning',
            message: '地址解析异常',
          }
          break
        case 5:
          tag = {
            type: 'default',
            message: '上传中',
          }
          break
        case 6:
          tag = {
            type: 'success',
            message: '上传成功',
          }
          break
        case 7:
          tag = {
            type: 'danger',
            message: '上传失败',
          }
          break
        default:
          break
      }
      return tag
    },
    async jumpImportOrder() {
      this.updateImportDialog = true
    },

    /** 文件预上传格式限制 */
    beforeUpload(file) {
      // 文件类型
      const isType = file.type === 'application/vnd.ms-excel'
      const isTypeComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      const fileType = isType || isTypeComputer
      if (!fileType) {
        this.$message.error('上传文件只能是xls/xlsx格式！')
      }

      // 文件大小限制为10M
      const fileLimit = file.size / 1024 / 1024 < 10
      if (!fileLimit) {
        this.$message.error('上传文件大小不超过10M！')
      }
      return fileType && fileLimit
    },

    /** 文件移除时 */
    handleRemove(file, fileList) {
      this.fileList = fileList
    },

    // 修复单文件上传 单选文件 覆盖已有文件
    uploadExceed(file, fileList) {
      // this.$set(fileList[0], 'raw', file[0])
      // this.$set(fileList[0], 'name', file[0].name)
      // this.$refs['upload'].clearFiles() // 清除文件
      // this.$refs['upload'].handleStart(fileList[0]) // 选择文件后的赋值方法

      this.$message.warning('超出1个文件，请先删除当前文件，再重新上传')
      return false
    },

    // 文件改变时
    fileChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]//这一步，是 展示最后一次选择文件
      }
      // this.fileList = fileList
      this.file = file
    },

    // 文件移除之前
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },

    async onUpdateImport() {
      if (!this.warehouse_code) {
        this.$message({
          type: 'warning',
          message: '请选择需要导入的仓库!',
        })
        return
      }

      if (this.fileList.length <= 0) {
        this.$message({
          type: 'warning',
          message: '请选择需要导入的Excel文件!',
        })
        return
      }

      await this.importOrderFile()
    },

    async importOrderFile() {
      const formData = new FormData()
      formData.append('file', this.file.raw)
      formData.append('warehouse_code', this.warehouse_code)
      const {
        data: { code, msg },
      } = await importOrder(formData).setConfig({
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      if (code == 1) {
        this.$message({
          type: 'error',
          message: msg,
        })
      } else {
        this.$message({
          type: 'success',
          message: '导入成功!',
        })

        this.file = null
        this.fileList = []
        this.updateImportDialog = false
        this.loadData()
      }
    },

    async onSubmitOrders() {
      const that = this
      for (let i = 0; i < that.orderImports.length; i++) {
        const item = that.orderImports[i]

        console.log('item', item)
        if (item.status === 6) {
          continue
        } else if (item.status === 2 || item.status === 3 || item.status === 4 || item.status === 9 || item.status === 8) {
          that.$notify({
            title: '错误',
            message: '序号【' + item.id + '】不满足要求，跳过导入；',
            type: 'warning',
          })
          continue
        }

        // 默认 1 待处理,2 重复数据,3 数据不完整,4 快递公司不在范围内,5 商品解析异常,6 地址解析异常,7 上传中,8 上传成功,9 上传失败
        that.orderImports[i].status = 5

        const form = {
          import_id: item.id,
        }
        // console.log('form:', form)

        const res = await importOrderOffline(form)
        console.log(res)
        if (res.status === 201) {
          that.orderImports[i].status = 6
          that.$notify({
            title: '成功',
            message: '序号【' + item.id + '】导入订单数据成功',
            type: 'success',
          })
        } else {
          that.orderImports[i].status = 7
          that.$notify({
            title: '错误',
            message: '序号【' + item.id + '】导入失败；原因:' + res.data.msg,
            type: 'error',
          })
        }
      }
      that.$message({
        message: '处理完成',
        type: 'success',
      })
      // 更新本地
      that.loadData()
    },

    async rsyncExport() {
      try {
        await exportOrder({ ...this.query })
        this.$message.success('离线下载中...')
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },

    async onDestroyConfirm(row) {
      const res = await destroyOrderImport(row.id)
      console.log(res)
      this.$message.success(getMessage('destroyed'))
      await this.loadData({})
    },
  },
}
</script>
